module.exports = __webpack_public_path__ + "img/(Old)Our-Team-KruNote.26e90d3e.jpg";